<template>
  <component
    :is="data.reference !== null ? NuxtLink : data.externalLink ? NuxtLink : 'span'"
    :to="
      data.reference
        ? usePathByType(data.reference._modelApiKey, data.reference.slug!)
        : data.externalLink
          ? data.externalLink
          : undefined
    "
    class="fx-txt-roll w-fit"
    :data-hover="data.title"
    ><span>
      {{ data.title }}
    </span>
  </component>

  <ul v-if="Array.isArray(data.children) && data.children.length" class="text-sm lg:text-base">
    <li v-for="item in data.children" :key="item!.id">
      <NuxtLink
        :to="
          item!.reference
            ? usePathByType(item!.reference._modelApiKey, item!.reference.slug!)
            : item!.externalLink
        "
        class="my-4 block w-fit"
        >{{ item!.title }}
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { MenuItemRecord } from '~/types/datocms'

const NuxtLink = resolveComponent('NuxtLink')

defineProps({
  data: {
    type: Object as PropType<MenuItemRecord>,
    default: () => {}
  }
})
</script>
